export default "__VITE_ASSET__DP05pBdG__"